/**
 * Populate YMM trim dropdowns from /apps/specr/api/tire-vin-trims.
 * Groups VDIM "Front" / "Rear" axle trims into one customer-facing option.
 */
(function (global) {
  var AXLE_SUFFIX_RE = /\s(front|rear)$/i;

  function groupRawTrims(trims) {
    var groups = {};
    var usedAxle = {};

    trims.forEach(function (name) {
      var frontMatch = name.match(/^(.+)\s+Front$/i);
      var rearMatch = name.match(/^(.+)\s+Rear$/i);
      if (frontMatch) {
        var base = frontMatch[1].trim();
        groups[base] = groups[base] || { value: base, label: base, staggered: true };
        usedAxle[name.toLowerCase()] = true;
      } else if (rearMatch) {
        var baseR = rearMatch[1].trim();
        groups[baseR] = groups[baseR] || { value: baseR, label: baseR, staggered: true };
        usedAxle[name.toLowerCase()] = true;
      }
    });

    var options = Object.keys(groups)
      .sort()
      .map(function (key) {
        return groups[key];
      });

    trims.forEach(function (name) {
      if (usedAxle[name.toLowerCase()]) return;
      if (AXLE_SUFFIX_RE.test(name)) return;
      options.push({ value: name, label: name, staggered: false });
    });

    return options.sort(function (a, b) {
      return a.label.localeCompare(b.label);
    });
  }

  function resolveTrimOptions(data) {
    if (data && data.trimOptions && data.trimOptions.length) {
      return data.trimOptions;
    }
    var trims = (data && data.trims) || [];
    if (!trims.length) return [];
    if (trims.some(function (t) {
      return AXLE_SUFFIX_RE.test(t);
    })) {
      return groupRawTrims(trims);
    }
    return trims.map(function (name) {
      return { value: name, label: name, staggered: false };
    });
  }

  function populateTrimSelect(trimSel, data) {
    if (!trimSel) return;
    var options = resolveTrimOptions(data);

    trimSel.innerHTML = "";
    var placeholder =
      trimSel.getAttribute("data-placeholder-trim") || "Trim (optional)";
    var anyOpt = document.createElement("option");
    anyOpt.value = "";
    anyOpt.textContent = options.length ? placeholder : "Trim (none listed)";
    trimSel.appendChild(anyOpt);

    options.forEach(function (opt) {
      var el = document.createElement("option");
      el.value = opt.value;
      el.textContent = opt.label || opt.value;
      trimSel.appendChild(el);
    });

    trimSel.disabled = false;
    if (options.length === 1) {
      trimSel.value = options[0].value;
    }
  }

  global.SpecrTireTrimSelect = {
    populate: populateTrimSelect,
    groupRawTrims: groupRawTrims,
    resolveTrimOptions: resolveTrimOptions,
  };
})(typeof window !== "undefined" ? window : globalThis);
